export default __webpack_public_path__ + "static/media/customer_service_operations.53b23898.png";